import { useState } from "react";
import { Box, useTheme } from "@mui/material";
import { useSwiper } from "swiper/react";
import MyButton from "../../../../_components/MyButton";
import PageLayout from "../../../../_components/PageLayout";
import videoFile from "./OnboardingCreateStrategy.mp4";

const WatchPromo = () => {
  const theme = useTheme();
  const swiper = useSwiper();

	const [isVideoEnded, setIsVideoEnded] = useState(false);

	const handleVideoEnded = () => setIsVideoEnded(true);

  const handleSlideNext = () => swiper.slideNext();

  return (
    <PageLayout
      bottomButton={
        <MyButton
          variant={isVideoEnded ? "primary" : "secondary"}
          withPaper
          onClick={handleSlideNext}
        >
          {isVideoEnded ? "Next" : "Skip"}
        </MyButton>
      }
    >
      <Box
        className="layout"
        sx={{
          backgroundColor: theme.myTheme.colors.bg,
          borderTopLeftRadius: "12px",
          borderTopRightRadius: "12px",
          padding: "8px 8px 0",
        }}
      >
        <Box sx={{
          height: "100%",
          paddingBottom:"38px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
					<Box sx={{
						width: "83%",
						position: "relative",
						top: "-30px",
						border: `1px solid ${theme.myTheme.colors.foreground50}`,
						borderRadius: "12px",
					}}>
					<video
            autoPlay
            muted
						controls
						onEnded={handleVideoEnded}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
							borderRadius: "12px",
            }}
          >
            <source src={videoFile} type="video/mp4" />
          </video>
					</Box>
        </Box>
      </Box>
    </PageLayout>
  );
};

export default WatchPromo;
